// extracted by css-extract-rspack-plugin
export default {"required":"qhS_TS"};